import Tracker from './tracker';
import { urlLogger } from './api';
import util from './utils/util';
import logger from './utils/logger';
import eCommerce from './modules/eCommerce';

!(function (window, location, navigator) {
    try {
        logger.debug('Index - creating trackers');
        logger.debug('DomodiTrackObject', window['DomodiTrackObject']);
        logger.debug('WphTrackObject', window['WphTrackObject']);

        const DEFAULT_NAME = 'wph';
        let trackers = [];
        let trackObject = window['DomodiTrackObject'] || window['WphTrackObject'];

        if (trackObject && trackObject.constructor === Array) {
            trackers = trackObject;
        } else {
            trackers.push(trackObject || DEFAULT_NAME);
        }

        trackers.forEach(trackerName => {
            const tracker = new Tracker(trackerName);
            const tro = window[trackerName];

            logger.debug('Temporary tracker object', trackerName, tro);
            logger.debug('Target tracker object', trackerName, tracker);

            tracker.registerModule(eCommerce);
            if (tro && tro.queue && tro.queue.constructor === Array) {
                tro.queue.forEach(item => tracker.push.apply(tracker, item));
            }
            window[trackerName] = tracker.push.bind(tracker);
        });
    } catch (error) {
        if (location.href.indexOf('http') !== -1) {
            const image = new Image(1, 1);
            const params = {
                t: 'error',
                v: process.env.APP_VERSION,
                h: location.href,
                m: error.message,
                ua: navigator.userAgent
            };

            if (error.stack) {
                params.s = error.stack;
            }

            image.src = urlLogger + '?' + util.toQueryString(params);
        }

        logger.warn(error);
    }
})(window, location, navigator);
